// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3f02G","approved":"Status_approved__2iMYL","rejected":"Status_rejected__rDjq7","expired":"Status_expired__2LJTN","label":"Status_label__22e-L"};